import React from 'react';
import styles from './PracticeCard.module.css';
import type { ForemanPractice } from '../../types/foreman';

interface PracticeCardProps {
  practice: ForemanPractice;
}

function getPriorityClass(priority: string): string {
  const p = priority.toLowerCase().replace(/[-_\s]/g, '');
  if (p === 'critical') return styles.priorityCritical;
  if (p === 'standard') return styles.priorityStandard;
  return styles.priorityNiceToHave;
}

const PracticeCard: React.FC<PracticeCardProps> = ({ practice }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.icon}>{'\u{1F4D6}'}</span>
        <span className={styles.headerLabel}>Practice Recorded</span>
      </div>

      <div className={styles.title}>{practice.title}</div>

      <div className={styles.details}>
        <span className={`${styles.pill} ${styles.categoryPill}`}>
          {practice.category}
        </span>
        <span className={`${styles.pill} ${styles.priorityPill} ${getPriorityClass(practice.priority)}`}>
          {practice.priority}
        </span>
      </div>

      {practice.taught_by && (
        <div className={styles.taughtBy}>
          Taught by <span className={styles.taughtByName}>{practice.taught_by}</span>
        </div>
      )}
    </div>
  );
};

export default PracticeCard;
